// extracted by mini-css-extract-plugin
module.exports = {"TermsDetails":"TermsAndConditions_TermsDetails__2hewV","mainParagraph":"TermsAndConditions_mainParagraph__1oz-g"};